<template>
  <div class="packPerformance">
    <div class="condition">
      <div class="condition_left">
        <div class="condition_left_item">
          <div class="condition_left_item_label">日期：</div>
          <el-date-picker
            class="condition_left_item_time"
            v-model="form.date"
            type="daterange"
            :editable="false"
            value-format="yyyy-MM-dd"
            :picker-options="{
              disabledDate: (date) => {
                return date && date > new Date();
              }
            }"
            :clearable="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <div class="condition_left_item">
          <el-input class="condition_left_item_input" v-model.trim="form.createBy" clearable placeholder="请输入姓名"></el-input>
        </div>
        <div class="condition_left_btnList">
          <el-button type="primary" @click="search">查询</el-button>
          <el-button  @click="reset">重置</el-button>
        </div>
      </div>
      <div class="condition_right">
        <el-button @click="exportList" :loading="exportLoading">导出</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="list"
        border
        style="width: 100%"
        :loading="listLoading">
        <el-table-column prop="name" label="姓名" min-width="120" fixed="left"></el-table-column>
        <el-table-column prop="date" label="日期" min-width="180" fixed="left"></el-table-column>
        <el-table-column prop="prescriptionCount" label="打包单量合计" min-width="140"></el-table-column>
        <el-table-column prop="drugsCount" label="中药处方单量" min-width="160"></el-table-column>
        <el-table-column prop="ylCount" label="医联产品单量" min-width="160"></el-table-column>
        <el-table-column prop="chineseDrugCount" label="中成药单量" min-width="160"></el-table-column>
        <el-table-column prop="otherCount" label="非处方项目单量" min-width="160"></el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        :page-sizes="pageSizes"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        :total="total"
        @current-change="pageNoChange"
        @size-change="pageSizeChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import { getPackPerformance, exportPackPerformance } from '@/api/statement';
  import { isMoreThanOneYear } from '@/utils/validateBase'
  import { Utils } from '@/utils/utils'
  import { CommonDTO } from '@/DTO/index'
  export default {
    name: 'PackPerformance',
    data() {
      return {
        deptId: sessionStorage.getItem('deptId'),
        form: {
          date: [],
          createBy: ''
        },
        pageSizes: [10, 20, 30, 50],
        pageNo: 1,
        pageSize: 10,
        total: 0,
        list: [],
        listLoading: false,
        exportLoading: false
      }
    },
    created() {
      let time = CommonDTO.getSystemTimeDTO()
      let startOfDay = Utils.timeFormat(Number(Utils.startOfDay(this.$moment(time))))
      let endOfDay = Utils.timeFormat(Number(Utils.endOfDay(this.$moment(time))))
      this.form.date = [startOfDay, endOfDay]
      this.getList();
    },
    methods: {
      getList() {
        this.listLoading = true;
        getPackPerformance({
          deptId: this.deptId,
          pageNum: this.pageNo,
          pageSize: this.pageSize,
          startDate: this.form.date && this.form.date[0] || '',
          endDate: this.form.date && this.form.date[1] || '',
          createBy: this.form.createBy
        }).then(res => {
          this.listLoading = false;
          if (res.code == 200) {
            this.list = res.data.data || [];
            this.total = res.data.totalElements;
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      pageNoChange(val) {
        this.pageNo = val;
        this.getList();
      },
      pageSizeChange(val) {
        this.pageNo = 1;
        this.pageSize = val;
        this.getList();
      },
      search() {
        this.pageNo = 1;
        // let HH = this.$moment().get('hour')
        // let flagOneDay = isMoreThanOneYear(this.form.date[0],  this.form.date[1], 1)
        // if(flagOneDay && HH < 22 && HH > 7 ) return this.$message.error('当前选择的日期范围大于1天，请22:00后查询')
        this.getList();
      },
      reset() {
        let time = CommonDTO.getSystemTimeDTO()
        let startOfDay = Utils.timeFormat(Number(Utils.startOfDay(this.$moment(time))))
        let endOfDay = Utils.timeFormat(Number(Utils.endOfDay(this.$moment(time))))
        this.form.date = [startOfDay, endOfDay]
        this.form.createBy = '';
        this.pageNo = 1;
        this.getList();
      },
      exportList() {
        this.exportLoading = true;
        exportPackPerformance({
          deptId: this.deptId,
          pageNum: this.pageNo,
          pageSize: this.pageSize,
          startDate: this.form.date && this.form.date[0] || '',
          endDate: this.form.date && this.form.date[1] || '',
          createBy: this.form.createBy
        }, { name: '配方单业绩',type:'csv' }).then(() => {
          this.exportLoading = false;
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .packPerformance{
    width: 100%;
  }

  .condition{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .condition_left{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .condition_left_item{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .condition_left_item_label{
    font-size: 16px;
    color: #333333;
  }

  .condition_left_item_time{
    width: 240px;
    font-size: 14px;
  }

  .condition_left_item_time.el-date-editor /deep/ .el-range__close-icon{
    line-height: 24px;
  }

  .condition_left_item_input{
    margin: 0 0 0 10px;
    width: 120px;
  }

  .condition_left_btnList{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 0 0 10px;
  }

  .table{
    margin: 20px 0 0 0;
  }

  .pagination{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 20px 0 0 0;
  }
</style>